module.exports = __webpack_public_path__ + "static/media/Adiber.bdfc2dc0.svg";